import type { AllRouteEndpoints } from "../routeTypes";

export const pushTokenStatusCacheKey = "/apps/user_info/:user_identifier/push_token_status" as const;
export const userInfoCacheKey = "/apps/user_info/:user_identifier" as const;
export const userInfosCacheKey = "/apps/user_infos/:user_identifier" as const;
export const userInfoAnyUsersCacheKey = "/apps/user_info_any_users" as const;
export const userInfoCampaignsCacheKey = "/apps/user_info_campaigns/:user_identifier" as const;
export const userInfoSegmentsCacheKey = "/apps/user_info_segments/:user_identifier" as const;
export const customObjectsLinkedToUserCacheKey =
  "/data_objects/:type_name/linked_to_user/:user_identifier" as const;
export const customObjectsNotLinkedToUserCacheKey =
  "/data_objects/:type_name/not_linked_to_user/:user_identifier" as const;
export const customObjectsBatchLinkUserCacheKey = "/data_objects/:type_name/users/:user_id/batch_link" as const;
export const customObjectsUserRelationshipCacheKey = "/data_objects/:type_name/:object_id/users/:user_id" as const;

export const customObjectsBusinessTabCacheKeys: AllRouteEndpoints[] = [
  customObjectsLinkedToUserCacheKey,
  customObjectsNotLinkedToUserCacheKey,
  customObjectsBatchLinkUserCacheKey,
];

export const SubscriptionStatuses = {
  UNSUBSCRIBED: 0,
  SUBSCRIBED: 1,
  OPTED_IN: 2,
} as const;
